/**
 * <igf-store-switch> — the Location & Contact picker.
 *
 * Every store's details are rendered server side; the select just decides
 * which one is shown. That keeps the panel correct with JavaScript off,
 * where the first store stays visible.
 */
class IgfStoreSwitch extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('select');
    this.panels = Array.from(this.querySelectorAll('[data-store]'));
    if (!this.select || this.panels.length === 0) return;

    this.select.addEventListener('change', () => this.show(this.select.value));
    this.show(this.select.value);
  }

  show(id) {
    this.panels.forEach((panel) => {
      const active = panel.dataset.store === id;
      panel.hidden = !active;
    });
  }
}

customElements.define('igf-store-switch', IgfStoreSwitch);
